/* ==========================================================================
   Neowalt — fiche produit : interactions (aucune dépendance)
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.querySelector('[data-nwp]');

  /* ─────────────── Ajout au panier ───────────────
     Les boutons secondaires déclenchent le formulaire natif Dawn :
     même comportement (tiroir, notification ou page panier) que le bouton principal. */
  function nativeForm() {
    return document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"][data-type="add-to-cart-form"]');
  }

  function addToCart(btn) {
    var form = nativeForm();
    var submit = form && form.querySelector('[type="submit"][name="add"], .product-form__submit');
    if (submit && submit.getAttribute('aria-disabled') !== 'true' && !submit.disabled) {
      btn.classList.add('is-loading');
      submit.click();
      var done = function () { btn.classList.remove('is-loading'); };
      var obs = new MutationObserver(function () {
        if (!submit.classList.contains('loading')) { obs.disconnect(); done(); }
      });
      obs.observe(submit, { attributes: true, attributeFilter: ['class'] });
      setTimeout(function () { obs.disconnect(); done(); }, 6000);
      return;
    }
    var idInput = form && form.querySelector('[name="id"]');
    if (!idInput) return;
    btn.classList.add('is-loading');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
    }).then(function () {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    }).catch(function () { btn.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var atc = e.target.closest('[data-nwp-atc]');
    if (atc) { e.preventDefault(); addToCart(atc); return; }
    var chat = e.target.closest('[data-nwp-chat]');
    if (chat && window.tidioChatApi && typeof window.tidioChatApi.open === 'function') {
      e.preventDefault();
      window.tidioChatApi.show && window.tidioChatApi.show();
      window.tidioChatApi.open();
    }
  });

  /* ─────────────── Date de livraison estimée ─────────────── */
  function parisNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return { date: new Date(Date.UTC(+o.year, +o.month - 1, +o.day)), h: +o.hour, m: +o.minute };
  }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(y, month - 1, day);
  }
  var holidayCache = {};
  function isHoliday(d) {
    var y = d.getUTCFullYear();
    if (!holidayCache[y]) {
      var day = 864e5, e = easter(y);
      holidayCache[y] = [
        Date.UTC(y, 0, 1), e + day, Date.UTC(y, 4, 1), Date.UTC(y, 4, 8), e + 39 * day, e + 50 * day,
        Date.UTC(y, 6, 14), Date.UTC(y, 7, 15), Date.UTC(y, 10, 1), Date.UTC(y, 10, 11), Date.UTC(y, 11, 25)
      ];
    }
    return holidayCache[y].indexOf(d.getTime()) !== -1;
  }
  function isBusiness(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && !isHoliday(d); }
  function addBusiness(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x = new Date(x.getTime() + 864e5); if (isBusiness(x)) n--; }
    return x;
  }
  var fmt = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
  function fr(d) { return fmt.format(d); }

  function renderEta(el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff'), 10) || 0;
    var shipDays = parseInt(el.getAttribute('data-ship-days'), 10);
    if (isNaN(shipDays)) shipDays = 1;
    var tMin = parseInt(el.getAttribute('data-transit-min'), 10) || 2;
    var tMax = parseInt(el.getAttribute('data-transit-max'), 10) || tMin;
    var now = parisNow();

    // Jour d'expédition
    var ship = now.date;
    var sameDay = cutoff > 0 && isBusiness(ship) && now.h < cutoff;
    if (sameDay) {
      shipDays = 0;
    } else if (!isBusiness(ship) || (cutoff > 0 && now.h >= cutoff)) {
      ship = addBusiness(ship, 1);
      shipDays = Math.max(0, shipDays - 1);
    }
    ship = addBusiness(ship, shipDays);
    var from = addBusiness(ship, tMin);
    var to = addBusiness(ship, tMax);

    var range = from.getTime() === to.getTime() ? '<strong>' + fr(from) + '</strong>'
      : 'entre le <strong>' + fr(from) + '</strong> et le <strong>' + fr(to) + '</strong>';
    var html = 'Livraison estimée ' + range + ' en point relais';
    if (sameDay) {
      var left = cutoff * 60 - (now.h * 60 + now.m);
      var hh = Math.floor(left / 60), mm = left % 60;
      html += '<br><span class="nwp-eta__cd">Commandez dans ' + (hh ? hh + ' h ' : '') + mm + ' min</span> pour un envoi aujourd’hui';
    }
    var txt = el.querySelector('[data-nwp-eta-text]');
    if (txt) txt.innerHTML = html;
  }
  document.querySelectorAll('[data-nwp-eta]').forEach(function (el) {
    try { renderEta(el); setInterval(function () { renderEta(el); }, 60000); } catch (err) { /* garde le texte serveur */ }
  });

  /* ─────────────── Variantes (stock + prix) ─────────────── */
  var variantData = null;
  var vEl = document.querySelector('[data-nwp-variants]');
  if (vEl) { try { variantData = JSON.parse(vEl.textContent); } catch (err) { variantData = null; } }
  function onVariant(id) {
    if (!variantData) return;
    var v = variantData.filter(function (x) { return x.id === Number(id); })[0];
    if (!v) return;
    var box = document.querySelector('[data-nwp-buybox]');
    var low = box ? parseInt(box.getAttribute('data-low'), 10) || 5 : 5;
    var stock = document.querySelector('[data-nwp-stock]');
    var txt = document.querySelector('[data-nwp-stock-text]');
    var state = !v.available ? 'out' : (v.tracked && v.qty <= 0 ? 'backorder' : (v.tracked && v.qty <= low ? 'low' : 'in'));
    if (stock) stock.setAttribute('data-state', state);
    if (txt) {
      txt.innerHTML = state === 'out' ? 'Rupture de stock'
        : state === 'backorder' ? 'Sur commande · expédition sous quelques jours'
        : state === 'low' ? 'Plus que <strong>' + v.qty + '</strong> en stock · expédié sous 24 h'
        : '<strong>En stock</strong> · prêt à être expédié';
    }
    document.querySelectorAll('[data-nwp-price]').forEach(function (p) { p.textContent = v.price; });
    document.querySelectorAll('[data-nwp-atc]').forEach(function (b) {
      b.disabled = !v.available;
    });
  }
  if (variantData && typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (e) {
      if (e && e.data && e.data.variant) onVariant(e.data.variant.id);
    });
  }

  if (!root) return;

  // Références conservées : certains navigateurs libèrent un observer que plus rien ne référence.
  var observers = root.__nwpObservers = [];
  function watch(el, cb, opts) {
    var o = new IntersectionObserver(cb, opts);
    o.observe(el);
    observers.push(o);
    return o;
  }

  /* ─────────────── Décalage sous l'en-tête collant ─────────────── */
  // Hauteur de l'en-tête une fois collé, recalculée seulement quand l'en-tête change.
  // Jamais pendant le défilement : réécrire cette variable à chaque image fait trembler
  // le sommaire collant sur Safari iOS (défilement par inertie).
  var header = document.querySelector('.section-header, sticky-header');
  var nav = root.querySelector('[data-nwp-nav]');
  var navTop = -1;
  function syncTop() {
    var top = 0;
    if (header && !header.classList.contains('shopify-section-header-hidden')) {
      var pos = getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') top = header.offsetHeight;
    }
    if (top === navTop) return;
    navTop = top;
    root.style.setProperty('--nwp-top', top + 'px');
  }
  syncTop();
  window.addEventListener('resize', syncTop);
  if (header) {
    // Menu déroulant, logo réduit, en-tête masqué au défilement (réglages Dawn)
    if ('ResizeObserver' in window) {
      var headRo = new ResizeObserver(syncTop);
      headRo.observe(header);
      observers.push(headRo);
    }
    // Dawn réécrit la classe de l'en-tête à chaque défilement, même inchangée : on filtre.
    var headCls = header.className;
    var headMo = new MutationObserver(function () {
      if (header.className === headCls) return;
      headCls = header.className;
      syncTop();
    });
    headMo.observe(header, { attributes: true, attributeFilter: ['class'] });
    observers.push(headMo);
  }

  /* ─────────────── Sommaire : lien actif + défilement doux ─────────────── */
  if (nav) {
    var links = [].slice.call(nav.querySelectorAll('.nwp-nav__links a'));
    var map = {};
    links.forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (target) map[id] = a;
      a.addEventListener('click', function (e) {
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + id);
      });
    });
    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var a = map[en.target.id];
        if (!a) return;
        links.forEach(function (l) { l.classList.toggle('is-active', l === a); });
        // Recentre le lien seulement s'il sort du sommaire : pas de glissement à chaque section.
        var list = a.parentElement.parentElement;
        var lr = list.getBoundingClientRect(), ar = a.getBoundingClientRect();
        if (ar.left < lr.left || ar.right > lr.right) {
          var left = list.scrollLeft + (ar.left - lr.left) - (lr.width - ar.width) / 2;
          list.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
    }, { rootMargin: '-35% 0px -60% 0px' });
    Object.keys(map).forEach(function (id) { spy.observe(document.getElementById(id)); });
  }

  /* ─────────────── Achat rapide collant ─────────────── */
  var mbar = root.querySelector('[data-nwp-mbar]');
  // Hors de la section : les wrappers Shopify peuvent créer un bloc conteneur (content-visibility, transform…)
  if (mbar && mbar.parentElement !== document.body) document.body.appendChild(mbar);
  var mainBtn = document.querySelector('.product-form__submit');
  var finalCard = root.querySelector('.nwp-final');
  var mainVisible = true, finalVisible = false, buyState = -1;
  function syncBuy() {
    var show = !mainVisible && !finalVisible;
    // On ne touche au DOM que lorsque l'état change, pas à chaque image de défilement.
    var state = (mainVisible ? 1 : 0) + (show ? 2 : 0);
    if (state === buyState) return;
    buyState = state;
    if (nav) nav.classList.toggle('is-buy', !mainVisible);
    if (mbar) {
      mbar.classList.toggle('is-on', show);
      mbar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var b = mbar.querySelector('button');
      if (b) b.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('nwp-mbar-on', show);
    }
  }
  // Lecture de position à chaque frame de défilement (lecture seule) : déterministe, quel que soit le conteneur.
  var buyTick = false;
  function checkBuy() {
    buyTick = false;
    var vh = window.innerHeight;
    var r = mainBtn ? mainBtn.getBoundingClientRect() : null;
    mainVisible = !r || r.bottom > navTop;
    var f = finalCard ? finalCard.getBoundingClientRect() : null;
    finalVisible = !!f && f.top < vh * 0.8 && f.bottom > vh * 0.2;
    syncBuy();
  }
  window.addEventListener('scroll', function () { if (!buyTick) { buyTick = true; requestAnimationFrame(checkBuy); } }, { passive: true });
  window.addEventListener('resize', checkBuy);
  checkBuy();

  /* ─────────────── Apparition au défilement ─────────────── */
  var reveals = [].slice.call(root.querySelectorAll('[data-nwp-reveal]'));
  if ('IntersectionObserver' in window && !reduce) {
    root.classList.add('is-ready');
    var groups = new Map();
    reveals.forEach(function (el) {
      var parent = el.parentElement;
      var i = groups.get(parent) || 0;
      el.style.setProperty('--d', Math.min(i, 6) * 70 + 'ms');
      groups.set(parent, i + 1);
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ─────────────── Halo qui suit le curseur ─────────────── */
  if (window.matchMedia('(hover: hover)').matches) {
    root.addEventListener('pointermove', function (e) {
      var card = e.target.closest('[data-nwp-spot]');
      if (!card) return;
      var r = card.getBoundingClientRect();
      card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
      card.style.setProperty('--my', (e.clientY - r.top) + 'px');
    });
  }

  /* ─────────────── Couches de sécurité ─────────────── */
  var layers = root.querySelector('[data-nwp-layers]');
  if (layers) {
    var items = [].slice.call(layers.querySelectorAll('.nwp-layer'));
    var rings = [].slice.call(layers.querySelectorAll('.nwp-ring'));
    var li = 0, lTimer = null, lHover = false;
    function setLayer(i) {
      li = i;
      var l = items[i].getAttribute('data-l');
      items.forEach(function (x, k) { x.classList.toggle('is-active', k === i); });
      rings.forEach(function (r) { r.classList.toggle('is-active', r.getAttribute('data-l') === l); });
    }
    items.forEach(function (x, k) {
      x.addEventListener('mouseenter', function () { lHover = true; setLayer(k); });
      x.addEventListener('mouseleave', function () { lHover = false; });
      x.addEventListener('focus', function () { setLayer(k); });
    });
    layers.classList.add('is-live');
    setLayer(0);
    if (!reduce) {
      watch(layers, function (en) {
        clearInterval(lTimer);
        if (en[0].isIntersecting) {
          lTimer = setInterval(function () { if (!lHover) setLayer((li + 1) % items.length); }, 3200);
        }
      }, { threshold: 0.35 });
    }
  }
})();
